export const Schema = () => ({
  // category: 'Article',
  label: 'Cumulative Impact',
  key: 'cumulativeImpact',
  fields: [
    {
      name: 'title',
      component: 'text',
      label: 'Title',
      description: 'Leave Blank to hide from Table of Contents',
    },
    {
      label: 'Body',
      name: 'body',
      component: 'markdown',
    },
  ],
});
